import { render, staticRenderFns } from "./DemoDebounce.vue?vue&type=template&id=aa525350&scoped=true"
import script from "./DemoDebounce.vue?vue&type=script&lang=js"
export * from "./DemoDebounce.vue?vue&type=script&lang=js"
import style0 from "./DemoDebounce.vue?vue&type=style&index=0&id=aa525350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa525350",
  null
  
)

export default component.exports